var React = require('react');

function CloseCircle (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M16.5 15.086l3.293-3.293a1 1 0 0 1 1.414 1.414L17.914 16.5l3.293 3.293a1 1 0 0 1-1.414 1.414L16.5 17.914l-3.293 3.293a1 1 0 0 1-1.414-1.414l3.293-3.293-3.293-3.293a1 1 0 0 1 1.414-1.414l3.293 3.293zm0 16.414c-8.284 0-15-6.716-15-15 0-8.284 6.716-15 15-15 8.284 0 15 6.716 15 15 0 8.284-6.716 15-15 15zm0-3c6.627 0 12-5.373 12-12s-5.373-12-12-12-12 5.373-12 12 5.373 12 12 12z"}));
}

CloseCircle.defaultProps = {"viewBox":"0 0 32 32"};

module.exports = CloseCircle;

CloseCircle.default = CloseCircle;
